import { Trans, useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import {
	CompleteAnim,
	EMlpIconTypes,
	EMplVariantTypes,
	MplButton,
	MplIconMessage,
	MplModal,
} from '@mopla/ui';

import { ICancellationDates, TSuccessModalVariant } from './types';

interface IDTicketCancelSuccessModalProps {
	open: boolean;
	onClose: () => void;
	variant: TSuccessModalVariant;
	dates: ICancellationDates;
}

export const DTicketCancelSuccessModal = ({
	open,
	onClose,
	variant,
	dates,
}: IDTicketCancelSuccessModalProps) => {
	const { t } = useTranslation('dticketSubscriptionCancel');

	const hasInfo = variant !== 'revoke' && variant !== 'preorder_cancel_in_time';

	const content = (
		<Stack gap={2}>
			<Typography variant="b1" color="primary.main">
				{t(`success_modal.${variant}.description`)}
			</Typography>
			{hasInfo && (
				<MplIconMessage
					type={EMlpIconTypes.Info}
					variant={EMplVariantTypes.Info}
					message={
						<Trans
							i18nKey={`dticketSubscriptionCancel:success_modal.${variant}.info`}
							values={dates}
							components={{ bold: <strong /> }}
						/>
					}
					dataTestid="dticket-cancelSuccessModal-info-iconMessage"
				/>
			)}
		</Stack>
	);

	return (
		<MplModal
			open={open}
			testId={`DTicketSubscriptionCancel-SuccessModal-${variant}`}
			icon={<CompleteAnim />}
			title={t(`success_modal.${variant}.title`, { ...dates })}
			content={content}
			buttons={
				<MplButton
					variant="contained"
					color="primary"
					fullWidth
					onClick={onClose}
					testId={`dticket-cancelSuccessModal-${variant}-close-button`}
				>
					{t(`success_modal.${variant}.button`)}
				</MplButton>
			}
		/>
	);
};
